import { BaseFormFieldProps, DetailsFormFieldProps, DisplayProps } from "models/propTypes/wintFormPropsTypes";
import DetailsFormBaseField from "./detailsFormBaseField";
import TextDisplay from "../formDisplays/textDisplay";
import CurrencySelectionInput from "../formFields/currencySelectionInput";

const CurrencySelectionField = (props: BaseFormFieldProps & DisplayProps & DetailsFormFieldProps) => {
  return <DetailsFormBaseField Display={TextDisplay} Input={CurrencySelectionInput} {...props} />;
};

export default CurrencySelectionField;
